<template>
  <div class="no-references-container">
    <div>
      <img id="no-ref-img" src="/images/no-references.png"/>
    </div>
    <div class="no-references-text">
      <div class="references-header">No account references to show for
        {{ selectedAccount && selectedAccount.name }}.
      </div>
      <div class="references-sub-header">Account references will appear here.</div>
      <br/>
      <div class="references-sub-header">
        <strong>Note:</strong> Change filters or search terms if you think you should be seeing account
        references.
      </div>
    </div>
  </div>
</template>

<script>
import './references.scss'

export default {
  name: "AccountReferencesNoData",
  props: ['selectedAccount']
};
</script>

<style scoped>

</style>
